import appEnv from '../../../env.js';

export default (state, getters) => {
  if (state.company.logo) {
    let basePath = appEnv.apiServerUrl + '/data/clients/';
    let fullAvatarUrl = basePath + state.company.logo;
    return fullAvatarUrl;
  }

  return false;
};



// WEBPACK FOOTER //
// ./src/store/getters/config/avatar.js